// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: #f8f9fa;
}

.webinars-section,
.trainings-section {
  background: rgb(245, 245, 245);
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 49%;
  flex-direction: column;
  display: flex;
}

.webinar-card,
.training-card {
  margin-bottom: 20px;
}

.webinar-card img {
  border-radius: 8px;
}

.webinar-content h3,
.training-card h3 {
  color: #333;
  font-size: 18px;
}

.training-section-list {
  height: 100%;
}

.webinar-list {
  height: 100%;
}

.training_section_btn {
  margin: 10px;
}

.webinar-content p,
.training-card p {
  font-size: 14px;
  color: #666;
}

.view-more {
  background: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.view-more:hover {
  background: #0056b3;
}

.webinars-section .webinar-item {
  padding: 30px 20px;
}
.webinars-section .webinar-item img {
  width: 100%;
  height: 100%;
}
.webinars-section_papermaking-content-des {
  padding-top: 5px;
}
.webinars-section_solutions-des {
  padding-top: 5px;
}
.webinars-section_recording-des {
  padding-top: 5px;
}
.webinars-section_content-heading {
  font-size: 14px;
  font-weight: 700;
  font-family: "ABBVoice";
}
.webinars-section .heading_section {
  background: rgba(51, 102, 255, 0.16);
  padding: 13px;
  border-radius: 10px 10px 0px 0px;
  font-size: 16px;
  font-weight: 700;
  margin: 8px;
}
.webinars-section .webinar_section_btn {
  margin: 10px;
}
.webinars-section .webinar-content {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
.webinars-section .webinar-content_des {
  color: rgb(0, 0, 0);
  font-weight: 400;
  font-size: 12px;
  font-family: "ABBVoice";
}
.webinars-section .webinar-content a {
  border-bottom: 1px solid rgb(51, 102, 255);
  text-decoration: none;
  font-weight: normal;
  padding: 0px;
  color: rgb(51, 102, 255);
  margin-top: auto;
  width: fit-content;
}

.trainings-section .heading_section {
  background: rgba(51, 102, 255, 0.16);
  padding: 13px;
  border-radius: 10px 10px 0px 0px;
  font-size: 16px;
  font-weight: 700;
  margin: 8px;
}
.trainings-section_ie-training {
  border-radius: 10px 10px 0px 0px;
  background: rgb(51, 102, 255) !important;
  color: rgb(255, 255, 255) !important;
  font-size: 14px !important;
  font-family: "ABBVoice" !important;
  font-weight: 500 !important;
}
.trainings-section_us_training {
  background: rgb(235, 235, 235);
  padding: 8px;
  font-size: 14px;
  font-weight: 700;
}
.trainings-section .training-box {
  padding: 10px;
}
.trainings-section .pl-12 {
  padding-left: 12px !important;
}
.trainings-section_sub_heading {
  padding: 20px 12px 0px 12px;
}
.trainings-section_sub_heading a {
  border-bottom: 1px solid rgb(51, 102, 255);
  text-decoration: none;
  font-weight: normal;
  padding: 0px;
  color: rgb(51, 102, 255);
}
.trainings-section .training_ie_section {
  padding: 10px;
}
.trainings-section .training_ie_section .header-bg-blue {
  padding: 6px 8px;
  background: rgba(51, 102, 255, 0.16);
  font-size: 14px;
  font-weight: 500;
}
.trainings-section_item {
  margin-top: 5px;
}
.trainings-section .gap-5 {
  gap: 5px;
}
.trainings-section .gap-10 {
  gap: 10px;
}
.trainings-section .p-lr-8 {
  padding: 0px 4px;
}
.trainings-section .pl-pr-10 {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
.trainings-section .pt-20 {
  padding-top: 20px;
}
.trainings-section .p-5 {
  padding: 5px;
}
.trainings-section .table-column {
  padding: 10px 0px;
}
.trainings-section .table-column a {
  border-bottom: 1px solid rgb(51, 102, 255);
  text-decoration: none;
  font-weight: normal;
  padding: 0px;
  color: rgb(51, 102, 255);
}

.view_more_btn {
  display: flex;
  justify-content: flex-end;
}
.view_more_btn .MuiButtonBase-root.MuiButton-root .label {
  color: #fff !important;
}

.my_learning_tabs .react-tabs__tab-list {
  border: 1px solid transparent !important;
  background-color: rgb(235, 235, 235);
  margin: 0;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab-list li:first-child {
  border-radius: 10px 0px 0px 0px !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab-list li:last-child {
  border-radius: 0px 10px 0px 0px !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab:focus:after {
  content: none !important;
  position: absolute;
  height: 5px;
  left: -4px;
  right: -4px;
  bottom: -5px;
  background: none;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab--selected {
  background: #f5f5f5 !important;
  color: black;
  font-weight: 600 !important;
  border-radius: 0px;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 2px solid #3366ff !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab--selected:focus-visible {
  outline: none !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab {
  display: inline-grid !important;
  justify-content: center !important;
  border-color: white;
  bottom: -1px;
  position: relative;
  list-style: none;
  padding: 6px 12px;
  cursor: pointer;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab-panel--selected {
  display: block;
  border: 1px solid #ebebeb !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab:first-child {
  border-radius: 6px 0px 0px 0px !important;
}
.my_learning_tabs .react-tabs__tab-list .react-tabs__tab:last-child {
  border-radius: 0px 6px 0px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/my_learing.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,8BAAA;EACA,kBAAA;EACA,2CAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,eAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;;EAEE,eAAA;EACA,WAAA;AAKF;;AAFA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAKF;;AAFA;EACE,mBAAA;AAKF;;AADE;EACE,kBAAA;AAIJ;AAFI;EACE,WAAA;EACA,YAAA;AAIN;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,gBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,oCAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAME;EACE,wBAAA;EACA,iCAAA;EACA,uBAAA;AAJJ;AAKI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAHN;AAKI;EACE,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AAHN;;AASE;EACE,oCAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AANJ;AASE;EACE,gCAAA;EACA,wCAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AAPJ;AAUE;EACE,8BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AARJ;AAWE;EACE,aAAA;AATJ;AAWE;EACE,6BAAA;AATJ;AAYE;EACE,2BAAA;AAVJ;AAYI;EACE,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AAVN;AAcE;EACE,aAAA;AAZJ;AAcI;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;AAZN;AAgBE;EACE,eAAA;AAdJ;AAiBE;EACE,QAAA;AAfJ;AAkBE;EACE,SAAA;AAhBJ;AAmBE;EACE,gBAAA;AAjBJ;AAmBE;EACE,8BAAA;EACA,6BAAA;AAjBJ;AAoBE;EACE,iBAAA;AAlBJ;AAqBE;EACE,YAAA;AAnBJ;AAsBE;EACE,iBAAA;AApBJ;AAsBI;EACE,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AApBN;;AAyBA;EACE,aAAA;EACA,yBAAA;AAtBF;AAwBE;EACE,sBAAA;AAtBJ;;AA2BE;EACE,wCAAA;EACA,oCAAA;EACA,SAAA;AAxBJ;AA0BI;EACE,0CAAA;AAxBN;AA2BI;EACE,0CAAA;AAzBN;AA4BI;EACE,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,8BAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EAEA,2CAAA;AA5BN;AA8BI;EACE,wBAAA;AA5BN;AA8BI;EACE,+BAAA;EACA,kCAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA5BN;AA+BI;EACE,cAAA;EACA,oCAAA;AA7BN;AAgCI;EACE,yCAAA;AA9BN;AAiCI;EACE,yCAAA;AA/BN","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  background-color: #f8f9fa;\n}\n\n.webinars-section,\n.trainings-section {\n  background: rgba(245, 245, 245, 1);\n  border-radius: 8px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  width: 49%;\n  flex-direction: column;\n  display: flex;\n}\n\n.webinar-card,\n.training-card {\n  margin-bottom: 20px;\n}\n\n.webinar-card img {\n  border-radius: 8px;\n}\n\n.webinar-content h3,\n.training-card h3 {\n  color: #333;\n  font-size: 18px;\n}\n.training-section-list {\n  height: 100%;\n}\n.webinar-list {\n  height: 100%;\n}\n.training_section_btn {\n  margin: 10px;\n}\n.webinar-content p,\n.training-card p {\n  font-size: 14px;\n  color: #666;\n}\n\n.view-more {\n  background: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.view-more:hover {\n  background: #0056b3;\n}\n\n.webinars-section {\n  .webinar-item {\n    padding: 30px 20px;\n\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &_papermaking-content-des {\n    padding-top: 5px;\n  }\n\n  &_solutions-des {\n    padding-top: 5px;\n  }\n\n  &_recording-des {\n    padding-top: 5px;\n  }\n\n  &_content-heading {\n    font-size: 14px;\n    font-weight: 700;\n    font-family: \"ABBVoice\";\n  }\n\n  .heading_section {\n    background: rgba(51, 102, 255, 0.16);\n    padding: 13px;\n    border-radius: 10px 10px 0px 0px;\n    font-size: 16px;\n    font-weight: 700;\n    margin: 8px;\n  }\n\n  .webinar_section_btn {\n    margin: 10px;\n  }\n\n  .webinar-content {\n    display: flex !important;\n    flex-direction: column !important;\n    height: 100% !important;\n    &_des {\n      color: rgba(0, 0, 0, 1);\n      font-weight: 400;\n      font-size: 12px;\n      font-family: \"ABBVoice\";\n    }\n    a {\n      border-bottom: 1px solid rgba(51, 102, 255, 1);\n      text-decoration: none;\n      font-weight: normal;\n      padding: 0px;\n      color: rgba(51, 102, 255, 1);\n      margin-top: auto;\n      width: fit-content;\n    }\n  }\n}\n\n.trainings-section {\n  .heading_section {\n    background: rgba(51, 102, 255, 0.16);\n    padding: 13px;\n    border-radius: 10px 10px 0px 0px;\n    font-size: 16px;\n    font-weight: 700;\n    margin: 8px;\n  }\n\n  &_ie-training {\n    border-radius: 10px 10px 0px 0px;\n    background: rgba(51, 102, 255, 1) !important;\n    color: rgba(255, 255, 255, 1) !important;\n    font-size: 14px !important;\n    font-family: \"ABBVoice\" !important;\n    font-weight: 500 !important;\n  }\n\n  &_us_training {\n    background: rgba(235, 235, 235, 1);\n    padding: 8px;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .training-box {\n    padding: 10px;\n  }\n  .pl-12 {\n    padding-left: 12px !important;\n  }\n\n  &_sub_heading {\n    padding: 20px 12px 0px 12px;\n\n    a {\n      border-bottom: 1px solid rgba(51, 102, 255, 1);\n      text-decoration: none;\n      font-weight: normal;\n      padding: 0px;\n      color: rgba(51, 102, 255, 1);\n    }\n  }\n\n  .training_ie_section {\n    padding: 10px;\n\n    .header-bg-blue {\n      padding: 6px 8px;\n      background: rgba(51, 102, 255, 0.16);\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n\n  &_item {\n    margin-top: 5px\n  }\n\n  .gap-5 {\n    gap: 5px;\n  }\n\n  .gap-10 {\n    gap: 10px;\n  }\n\n  .p-lr-8 {\n    padding: 0px 4px;\n  }\n  .pl-pr-10 {\n    padding-right: 10px !important;\n    padding-left: 10px !important;\n  }\n\n  .pt-20 {\n    padding-top: 20px;\n  }\n\n  .p-5 {\n    padding: 5px;\n  }\n\n  .table-column {\n    padding: 10px 0px;\n\n    a {\n      border-bottom: 1px solid rgba(51, 102, 255, 1);\n      text-decoration: none;\n      font-weight: normal;\n      padding: 0px;\n      color: rgba(51, 102, 255, 1);\n    }\n  }\n}\n\n.view_more_btn {\n  display: flex;\n  justify-content: flex-end;\n\n  .MuiButtonBase-root.MuiButton-root .label {\n    color: #fff !important;\n  }\n}\n\n.my_learning_tabs {\n  .react-tabs__tab-list {\n    border: 1px solid transparent !important;\n    background-color: rgba(235, 235, 235, 1);\n    margin: 0;\n\n    .react-tabs__tab-list li:first-child {\n      border-radius: 10px 0px 0px 0px !important;\n    }\n\n    .react-tabs__tab-list li:last-child {\n      border-radius: 0px 10px 0px 0px !important;\n    }\n\n    .react-tabs__tab:focus:after {\n      content: none !important;\n      position: absolute;\n      height: 5px;\n      left: -4px;\n      right: -4px;\n      bottom: -5px;\n      background: none;\n    }\n\n    .react-tabs__tab--selected {\n      background: #f5f5f5 !important;\n      color: black;\n      font-weight: 600 !important;\n      border-radius: 0px;\n      border-top: none !important;\n      border-left: none !important;\n      border-right: none !important;\n\n      border-bottom: 2px solid #3366ff !important;\n    }\n    .react-tabs__tab--selected:focus-visible {\n      outline: none !important;\n    }\n    .react-tabs__tab {\n      display: inline-grid !important;\n      justify-content: center !important;\n      border-color: white;\n      bottom: -1px;\n      position: relative;\n      list-style: none;\n      padding: 6px 12px;\n      cursor: pointer;\n    }\n\n    .react-tabs__tab-panel--selected {\n      display: block;\n      border: 1px solid #ebebeb !important;\n    }\n\n    .react-tabs__tab:first-child {\n      border-radius: 6px 0px 0px 0px !important;\n    }\n\n    .react-tabs__tab:last-child {\n      border-radius: 0px 6px 0px 0px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
